import React, { useState } from 'react';
import Jury_1 from '../img/jury/jury_1.jpg'
import Jury_2 from '../img/jury/jury_2.jpg'
import Jury_3 from '../img/jury/jury_3.jpg'
import Jury_4 from '../img/jury/jury_4.jpg'
import Jury_5 from '../img/jury/jury_5.jpg'
import Jury_6 from '../img/jury/jury_6.jpg'
import Jury_7 from '../img/jury/jury_7.jpg'
import Jury_8 from '../img/jury/jury_8.jpg'
import Jury_9 from '../img/jury/jury_9.jpeg'
import Jury_10 from '../img/jury/jury_10.jpg'
import Jury_11 from '../img/jury/jury_11.jpg'
import Jury_12 from '../img/jury/jury_12.jpeg'
import Jury_13 from '../img/jury/jury_13.jpg'
import Jury_14 from '../img/jury/jury_14.jpg'
import Jury_15 from '../img/jury/jury_15.jpg'
import Jury_16 from '../img/jury/jury_16.jpg'
import Jury_17 from '../img/jury/jury_17.jpg'
import Jury_18 from '../img/jury/jury_18.jpeg'
import Jury_19 from '../img/jury/jury_19.jpg'
import Jury_20 from '../img/jury/jury_20.jpg'

const juryData = {
  2024: [
    { name: 'Сергей Власенко', country: 'Россия', desc: 'Генеральный директор крупнейшего строительного холдинга России, участвовал в разработке программы по модернизации инфраструктуры, включающей строительство современных транспортных узлов и жилых комплексов.', image: Jury_1 },
    { name: 'Динара Омарова', country: 'Казахстан', desc: 'Эксперт по устойчивому строительству, разработала ряд проектов в области экодевелопмента, включая жилые комплексы с нулевым уровнем выбросов углерода.', image: Jury_2 },
    { name: 'Александр Ковтун', country: 'Беларусь', desc: 'Ведущий инженер-конструктор, автор инновационной системы усиления несущих конструкций в сейсмоопасных районах, внедренной в Украине и Грузии.', image: Jury_3 },
    { name: 'Фарид Алиев', country: 'Азербайджан', desc: 'Специалист по цифровой трансформации в строительстве, инициатор внедрения BIM-технологий в проектировании и реализации государственных инфраструктурных объектов.', image: Jury_4 },
  ],
  2023: [
    { name: 'Олег Романов', country: 'Беларусь', desc: 'Профессор архитектуры, разработал авторскую методику проектирования энергоэффективных зданий, которая была принята в качестве стандарта в Беларуси.', image: Jury_5 },
    { name: 'Михаил Гайдук', country: 'Россия', desc: 'Генеральный директор инжиниринговой компании, занимался проектированием и реализацией крупнейших промышленных объектов, включая нефтеперерабатывающие заводы.', image: Jury_6 },
    { name: 'Айнура Бекетова', country: 'Казахстан', desc: 'Ведущий эксперт по урбанистике, автор концепции "умных городов" в Центральной Азии, внедренной в нескольких крупных мегаполисах Казахстана.', image: Jury_7 },
    { name: 'Владимир Карпенко', country: 'Россия', desc: 'Инженер-строитель, возглавил проект по реконструкции исторических объектов с использованием современных технологий, сохраняя их аутентичный облик.', image: Jury_8 },
  ],
  2022: [
    { name: 'Рустам Саидов', country: 'Узбекистан', desc: 'Директор крупной строительной корпорации, участвовал в разработке новых стандартов контроля качества в сфере высотного строительства.', image: Jury_9 },
    { name: 'Людмила Кравченко', country: 'Россия', desc: 'Специалист по экологичному строительству, разработала технологии переработки строительных отходов в новые материалы, что позволило снизить себестоимость строительства.', image: Jury_10 },
    { name: 'Дмитрий Иванченко', country: 'Россия', desc: 'Генеральный директор компании по автоматизации строительства, внедрил технологии ИИ для оптимизации проектных решений.', image: Jury_11 },
    { name: 'Анар Гусейнов', country: 'Азербайджан', desc: 'Ведущий архитектор, разработал концепцию строительства новых жилых районов с учетом традиционной азербайджанской архитектуры и современных технологий.', image: Jury_12 },
  ],
  2021: [
    { name: 'Станислав Пономарёв', country: 'Беларусь', desc: 'Директор строительного института, автор более 20 научных трудов по инновационным материалам и устойчивому строительству.', image: Jury_13 },
    { name: 'Айжан Нурбекова', country: 'Казахстан', desc: 'Ведущий специалист по промышленному строительству, участвовала в проектировании новых производственных мощностей с учетом современных экологических стандартов.', image: Jury_14 },
    { name: 'Игорь Михайлов', country: 'Россия', desc: 'Эксперт по градостроительству, разрабатывал концепции транспортной инфраструктуры, внедренные в крупнейших городах СНГ.', image: Jury_15 },
    { name: 'Тимур Алиев', country: 'Азербайджан', desc: 'Разработчик программных решений для цифрового контроля строительства, внедренных в государственных проектах Азербайджана.', image: Jury_16 },
  ],
  2020: [
    { name: 'Валерий Лисенко', country: 'Украина', desc: 'Инженер-конструктор, разработал системы антисейсмической защиты зданий, внедренные в нескольких странах СНГ.', image: Jury_17 },
    { name: 'Мария Орлова', country: 'Беларусь', desc: 'Архитектор, специализирующаяся на реконструкции исторических зданий, ее проекты получили международные премии за сохранение культурного наследия.', image: Jury_18 },
    { name: 'Ермек Сагадиев', country: 'Казахстан', desc: 'Строительный технолог, возглавил разработку инновационных строительных материалов с улучшенной теплоизоляцией.', image: Jury_19 },
    { name: 'Сергей Горбатов', country: 'Россия', desc: 'Один из основателей компании, занимающейся внедрением роботизированных технологий в строительстве, что значительно повысило производительность отрасли.', image: Jury_20 },
  ]
};

const Jury = () => {
    const [currentYear, setCurrentYear] = useState(2024);
    const years = [2024, 2023, 2022, 2021, 2020];
  
    return (
      <div className="jury-section">
        <div className="jury-tabs">
          {years.map((year) => (
            <div
              key={year}
              className={`jury-tab ${currentYear === year ? 'active' : ''}`}
              onClick={() => setCurrentYear(year)}
            >
              {year}
            </div>
          ))}
        </div>
  
        <h2 className="jury-title">Жюри {currentYear}</h2>
  
        <div className="jury-grid">
          {juryData[currentYear].map((jury, index) => (
            <div key={index} className="jury-card">
              <img
                className="jury-img"
                src={jury.image}
                alt={jury.name}
              />
              <div className="jury-info">
                <h3>{jury.name} ({jury.country})</h3>
                <p>{jury.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default Jury;
